interface ReplyMessage {
  id?: string | null;
  role: "user" | "assistant";
  content: string;
  isError?: boolean;
}

export interface AssistantReplySummary {
  key: string;
  preview: string;
  isError: boolean;
}

function firstReplyLine(content: string): string {
  return (content.split(/\r?\n/, 1)[0] ?? "")
    .replace(/^#+\s*/, "")
    .replace(/[*_`~]/g, "")
    .trim();
}

export function latestAssistantReply(
  messages: readonly ReplyMessage[]
): AssistantReplySummary | null {
  for (let index = messages.length - 1; index >= 0; index -= 1) {
    const message = messages[index];
    if (message.role !== "assistant") continue;
    return {
      key: message.id ?? `${index}:${message.content}`,
      preview: firstReplyLine(message.content),
      isError: Boolean(message.isError),
    };
  }
  return null;
}
